import { render } from "./addZizhanghao.vue?vue&type=template&id=13e4444b&scoped=true"
import script from "./addZizhanghao.vue?vue&type=script&lang=js"
export * from "./addZizhanghao.vue?vue&type=script&lang=js"

import "./addZizhanghao.vue?vue&type=style&index=0&id=13e4444b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e4444b"]])

export default __exports__